/**  @module Apparel/PrintDesign/NewPrintPosition */
define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/locale",
	"Apparel/PrintDesign/PrintPositionMixin"
], function(declare,New,locale,PrintPositionMixin) {

	return declare([New,PrintPositionMixin], {
		
	});
});